module.exports = __webpack_public_path__ + "static/media/london-16.08732e9c.svg";